export default __webpack_public_path__ + "static/media/Josephine.683e9fd6.png";